<div class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form>
            <ng-container>
              <div class="my-4">
                <h6>RESERVED INSTANCE DETAILS</h6>
                <div class="my-4">
                  <!-- <div class="my-2">
                    NAME :<span class="red-bold"> {{from.out_stock_code}}</span> <br>
                  </div>
    
                  <div class="mt-4" style="display: flex;justify-content: center;">
                    <button class="button button-red button-large" 
                      (click)="calculate()">Request For Return</button>
                  </div> -->
    
                </div>
              </div>
              <hr>
            </ng-container>
          </form>
        </div>

      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
